/*
 *   Copyright (c) 2026, CYBRA Corp. All rights reserved. 
 */

import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { AblenetExpReturnDevicesValidationService, ValidationInfoDto } from "app/services/ablenet.expreturndevices.service";

/**
 * Resolves the "AbleNet Portal Validation State" for the Portal whose ID is in the "id" parameter
 * in the page path. 
 */
@Injectable()
export class AbleNetExpReturnDevicesStateResolver implements Resolve<ValidationInfoDto> {

  /** Constructor */
  constructor(
    private ableNetExpReturnDevicesValidationService: AblenetExpReturnDevicesValidationService
  ) {}

  /** Obtains the data to be resolved in the background. */
  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ValidationInfoDto> {
    // Get the 'ID' Path parameter which is the ID of the Service to obtain...
    const id = route.paramMap.get('id');    
    if (id == null || id.length == 0) {
      return null;
    }

    // Call the API to retrieve the current state for the Portal with the given ID
    return await this.ableNetExpReturnDevicesValidationService.getCurrentState(id);
  }

}
